import { FormattedMessage } from 'react-intl';
import { SensorType } from '../../../../../types/SensorType';

export const ADMIN_TRIGGER_OPTIONS = [
  {
    value: SensorType.HOME,
    label: <FormattedMessage defaultMessage="HOME" id="3jvkEL" />,
    inputType: 'checkbox',
  },
  {
    value: SensorType.SPLITSCREEN,
    label: <FormattedMessage defaultMessage="SplitScreen" id="3dC9e0" />,
    inputType: 'checkbox',
  },
  {
    value: SensorType.NEXMO_NFC,
    label: <FormattedMessage defaultMessage="NFC Reader" id="1rhYzD" />,
    inputType: 'textfield',
  },
  {
    value: SensorType.NEXMO_PICKUP,
    label: <FormattedMessage defaultMessage="Pickup" id="7uP+Kl" />,
    inputType: 'input',
  },
  {
    value: SensorType.GENERIC,
    label: <FormattedMessage defaultMessage="Generic" id="IL4EQo" />,
    inputType: 'textfieldJSON',
  },
  {
    value: SensorType.TH_PUSH,
    label: <FormattedMessage defaultMessage="Trihow Push" id="tnVnMQ" />,
    inputType: 'input',
  },
  {
    value: SensorType.NEXMO_BUTTON,
    label: <FormattedMessage defaultMessage="Button" id="KP63fg" />,
    inputType: 'input',
  },
  {
    value: SensorType.NEXMO_PRESENCE_XY240,
    label: <FormattedMessage defaultMessage="Presence" id="X5iyxs" />,
    inputType: 'input',
  },
  {
    value: SensorType.UHF_NEO_DESKTOP,
    label: <FormattedMessage defaultMessage="UHF Reader" id="BYJQM/" />,
    inputType: 'textfield',
  },
  {
    value: SensorType.TOUCH,
    label: <FormattedMessage defaultMessage="Touch" id="lDEhUP" />,
    inputType: 'textfieldJSON',
  },
];

export const NON_ADMIN_TRIGGER_OPTIONS = [
  {
    value: SensorType.HOME,
    label: <FormattedMessage defaultMessage="HOME" id="3jvkEL" />,
    inputType: 'checkbox',
  },
  {
    value: SensorType.SPLITSCREEN,
    label: <FormattedMessage defaultMessage="SplitScreen" id="3dC9e0" />,
    inputType: 'checkbox',
  },
  {
    value: SensorType.NEXMO_NFC,
    label: <FormattedMessage defaultMessage="NFC Reader" id="1rhYzD" />,
    inputType: 'textfield',
  },
  {
    value: SensorType.TH_PUSH,
    label: <FormattedMessage defaultMessage="Trihow Push" id="tnVnMQ" />,
    inputType: 'input',
  },
];

export const TRIHOWPAD_TRIGGER_OPTIONS = [
  {
    value: SensorType.HOME,
    label: <FormattedMessage defaultMessage="HOME" id="3jvkEL" />,
    inputType: 'checkbox',
  },
  {
    value: SensorType.NEXMO_NFC,
    label: <FormattedMessage defaultMessage="NFC Reader" id="1rhYzD" />,
    inputType: 'textfield',
  },
];

export const getTriggerOptions = (isAdmin: boolean, isTrihowPad: boolean) => {
  if (isAdmin && isTrihowPad) {
    return TRIHOWPAD_TRIGGER_OPTIONS;
  }
  if (isAdmin) {
    return ADMIN_TRIGGER_OPTIONS;
  }
  return NON_ADMIN_TRIGGER_OPTIONS;
};
